import { Tag } from "@blueprintjs/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon";
import ChevronRight from "@material-ui/icons/ChevronRight";
import * as React from "react";
import styled from "~/styled";

interface IProps {
  icon: React.ComponentType<SvgIconProps>;
  title?: string | React.ReactNode;
  tag?: string | React.ReactNode;
  description?: string | React.ReactNode;
  description_html?: string;
  chevron?: boolean;
  workingTime?: boolean;
}

const TopicWrapper = styled.div`
  display: grid;

  grid-template-areas:
    "icon title chevron"
    "icon description chevron";

  align-items: center;
  grid-template-columns: auto 1fr auto;
  grid-row-gap: 8px;
  grid-column-gap: 24px;
`;

const IconWrapper = styled.div`
  grid-area: icon;
  color: ${props => props.theme.brandColor.primary};
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Title = styled.h4`
  grid-area: title;

  margin: 0 10px 0 0;
  color: ${props => props.theme.brandColor.primary};
  font-size: 18px;
  font-weight: 500;

  @media (max-width: 568px) {
    font-size: 16px;
  }

  @media (max-width: 375px) {
    font-size: 14px;
  }

  @media (max-width: 320px) {
    font-size: 12px;
  }
`;

const Description = styled.p`
  grid-area: description;

  margin: 0 0 15px 0;

  @media (max-width: 568px) {
    font-size: 14px;
  }

  @media (max-width: 375px) {
    font-size: 12px;
  }

  @media (max-width: 320px) {
    font-size: 10px;
  }
`;

const Chevron = styled(ChevronRight)`
  grid-area: chevron;

  color: #333;
`;

export default class Topic extends React.Component<IProps> {
  public render() {
    const {
      icon: Icon,
      title,
      tag,
      description,
      description_html,
      chevron = false,
      workingTime = true
    } = this.props;

    return (
      <TopicWrapper>
        <IconWrapper>
          <Icon />
        </IconWrapper>

        <TitleWrapper>
          {title ? <Title>{title}</Title> : null}

          {tag ? (
            <Tag intent={workingTime ? "success" : "danger"}>{tag}</Tag>
          ) : null}
        </TitleWrapper>

        {description || description_html ? (
          <Description>
            {description_html && (
              <div dangerouslySetInnerHTML={{ __html: description_html }} />
            )}

            {description && description}
          </Description>
        ) : null}

        {chevron ? <Chevron /> : null}
      </TopicWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CustomerSupport/Topic.tsx